import { useEffect, useState } from "react";
import axios from "axios";
import { useAuth, API } from "../App";

/**
 * Poll pending match reminders every 60s while the user is signed in.
 * A "reminder" is a Men's First Team fixture kicking off within the next
 * 2 hours that the user has NOT yet submitted a prediction for.
 */
export function useMatchReminders() {
  const { user } = useAuth();
  const [reminders, setReminders] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!user) {
      setReminders([]);
      return undefined;
    }

    let cancelled = false;

    const fetchReminders = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(`${API}/score-predictor/pending-reminders`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!cancelled) setReminders(res.data.reminders || []);
      } catch (e) {
        // Silent — feature is non-critical
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchReminders();
    const interval = setInterval(fetchReminders, 60000);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, [user]);

  return { reminders, count: reminders.length, loading };
}
